import { useState } from 'react';

export const useNotificationItem = () => {
  const [expanded, setExpanded] = useState(false);

  return {
    expanded,
    setExpanded,
  };
};
